<template>
  <div class="layout-footer">
    <div class="layout-footer-content">
      <div class="column about">
        <div class="title">关于科度</div>
        <router-link class="info link" to="/aboutUs#brief-introduction">
          公司简介
        </router-link>
        <router-link class="info link" to="/aboutUs#corporate-culture">
          企业文化
        </router-link>
        <router-link class="info link" to="/aboutUs#corporate-history">
          公司历程
        </router-link>
        <router-link class="info link" to="/aboutUs#corporate-qualification">
          公司资质
        </router-link>
      </div>
      <div class="column about">
        <div class="title">解决方案</div>
        <router-link class="info link" to="/solution/1">
          反诈中心解决方案
        </router-link>
        <router-link class="info link" to="/solution/3">
          反诈联盟解决方案
        </router-link>
        <router-link class="info link" to="/solution/2">
          侦查中心解决方案
        </router-link>
        <router-link class="info link" to="/solution/4">
          警校数据侦查实验室
        </router-link>
        <router-link class="info link" to="/solution/5">
          防控治理中心解决方案
        </router-link>
      </div>
      <div class="column about">
        <div class="title">核心产品</div>
        <router-link class="info link" to="/product/1">
          预警劝阻平台
        </router-link>
        <router-link class="info link" to="/product/2">
          案件侦办平台
        </router-link>
        <router-link class="info link" to="/product/3">
          线索侦研平台
        </router-link>
        <router-link class="info link" to="/product/4">
          自动止付（反制通）
        </router-link>
        <router-link class="info link" to="/product/5">
          数据智能分析（小刀）
        </router-link>
        <router-link class="info link" to="/product/6">
          防控治理警务平台
        </router-link>
        <router-link class="info link" to="/product/7">
          安全协作平台
        </router-link>
        <router-link class="info link" to="/product/8">
          两卡治理小程序
        </router-link>
        <router-link class="info link" to="/product/9">
          企业申诉救济
        </router-link>
      </div>
      <div class="column serve">
        <div class="title">服务与支持</div>
        <div class="info">电话咨询：0571-88665218</div>
        <div class="info">售后服务：kedu@ketech.com.cn</div>
        <div class="info">商务合作：kedu@ketech.com.cn</div>
        <div class="info">工作时间：8:30-17:30（工作日）</div>
      </div>
      <div class="column wechat">
        <img
          v-lazyload
          class="qr-image no-right-click"
          :data-src="QRCode"
          alt="qr"
          srcset=""
        />
        <span class="qr-image-text"> 扫码关注公众号 </span>
      </div>
    </div>

    <div class="footer_copyright">
      Copyright © 2014 杭州科度科技有限公司 All Rights Reserved ·
      <a target="_blank" href="https://beian.miit.gov.cn">
        浙ICP备14026837号-1
      </a>
      ·
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002012439"
      >
        浙公网安备 33011002012439号
      </a>
    </div>
  </div>
</template>

<script>
import QRCode from '@/assets/images/wechatQr.jpg'
export default {
  name: 'LayoutFooter',
  data() {
    return {
      QRCode
    }
  }
}
</script>
<style lang="less" scoped>
.layout-footer {
  .layout-footer-content {
    display: flex;
    display: -ms-flexbox;
    margin: 64px auto 40px;
    padding-bottom: 40px;
    max-width: 1200px;
    justify-content: space-between;
    -ms-flex-pack: space-between;
    border-bottom: 1px solid #312b28;
    .column {
      .title {
        display: block;
        margin-bottom: 32px;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.5%;
        color: #ffffff;
        // text-decoration: none;
        // &:hover {
        //   text-decoration: underline;
        // }
      }
      .info {
        display: block;
        margin-bottom: 24px;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.5%;
        color: #ffeff0;
        text-decoration: none;
      }
    }
    .wechat {
      display: flex;
      display: -ms-flexbox;
      width: 194px;
      flex-direction: column;
      -ms-flex-direction: column;
      align-items: center;
      .qr-image {
        width: 166px;
        height: 166px;
        border-radius: 4px;
      }
      .qr-image-text {
        margin-top: 16px;
        font-weight: 500;
        font-size: 16px;
        line-height: 120%;
        letter-spacing: 0.5%;
        color: #ffffff;
      }
    }
    .link {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .footer_copyright {
    margin: 40px auto 64px;
    text-align: center;
    color: white;
    a {
      color: white;
    }
  }
}
@media screen and (max-width: 1200px) {
  .layout-footer .layout-footer-content {
    display: none;
  }
}
</style>
